export class FilterKeyValue {
    key: string;
    value: string;
}
export class FilterModel {
    keyValues: FilterKeyValue[] = [];
    orCondition: boolean = false;
    serversideFiltering: boolean = false;
    serversideUrl?: string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/sui/sui.util/sui.util.filter.model.ts